import React, { type SyntheticEvent } from 'react'
import Autocomplete from '@mui/joy/Autocomplete'
import { useTranslation } from 'react-i18next'
import { usePlacesAutocomplete } from 'places-autocomplete-hook'

import { SearchIcon } from './icons'

export default function PlacesAutocomplete({
    location,
    handleSelect,
} : {
    location: string | null,
    handleSelect: (event: SyntheticEvent | null, newValue: string | null, name : string) => void,
}) {

    const { t, i18n } = useTranslation()
    const userLang = i18n.language as 'cs' | 'en' | 'de' | 'pl'

    const {
        suggestions: { status, data },
        setValue,
    } = usePlacesAutocomplete({
        apiKey: import.meta.env.VITE_GOOGLE_MAPS_KEY,
        includedRegionCodes: ['CZ'],
        language: userLang,
        debounceMs: 800,
        location: {
            lat: 50.0755381,
            lng: 14.4378005,
            radius: 20000, // 20km radius
        },
    })

    return(
        <Autocomplete
            startDecorator={<SearchIcon color="#BDBDBD"/>}
            placeholder={t('search.wherePlaceholder')}
            freeSolo
            disableClearable
            onChange={(event, newValue) => {
                handleSelect(event, newValue, 'location')
            }}
            onInputChange={(event, newInputValue) => {
                handleSelect(event, newInputValue, 'location')
                setValue(newInputValue)
            }}
            loading={status !== "OK"}
            loadingText={t('search.whereEmpty')}
            value={location ?? ''}
            inputValue={location ?? ''}
            options={status === "OK" ? data.map(({ text }) => text.text) : []}
            sx={{
                backgroundColor: 'white',
                //boxShadow: 'none',
                lineHeight: '28px',
            }}
            slotProps={{
                listbox: {
                    sx: () => ({
                        zIndex: 2000,
                        backgroundColor: 'white',
                    })
                }
            }}
        />
    )
}
